module.exports = __webpack_public_path__ + "img/t2-salmon.19be247f.png";